import React from "react";
import { Store } from "lucide-react";

interface HeaderProps {
  selectedLojaId?: number;
  selectedLojaNome?: string;
}

export const Header: React.FC<HeaderProps> = ({
  selectedLojaId,
  selectedLojaNome,
}) => {
  return (
    <div className="mt-4 px-4 py-3 text-center sm:mt-6 sm:py-4">
      <h1 className="mb-2 bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-2xl font-black text-transparent sm:text-3xl lg:text-4xl">
        META DE PRODUÇÃO COLETIVA
      </h1>
      {selectedLojaId && selectedLojaNome && (
        <div className="flex items-center justify-center gap-2 text-sm opacity-75 sm:text-base">
          <Store className="h-4 w-4" />
          <span>{selectedLojaNome}</span>
        </div>
      )}
    </div>
  );
};
